"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.5 22.6",
    width: "20.5",
    height: "22.6"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.3,9.2C4.5,9.2,0,7.2,0,4.6S4.5,0,10.3,0s10.3,2,10.3,4.6S16,9.2,10.3,9.2z M10.3,1C4.8,1,1,2.9,1,4.6s3.8,3.6,9.3,3.6 s9.3-1.9,9.3-3.6S15.7,1,10.3,1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.3,13.3C4.5,13.3,0,11.3,0,8.7c0-0.3,0.2-0.5,0.5-0.5S1,8.4,1,8.7c0,1.7,3.8,3.6,9.3,3.6s9.3-1.9,9.3-3.6 c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5C20.5,11.3,16,13.3,10.3,13.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.3,17.9c-5.7,0-10.3-2-10.3-4.6c0-0.3,0.2-0.5,0.5-0.5S1,13.1,1,13.3c0,1.7,3.8,3.6,9.3,3.6s9.3-1.9,9.3-3.6 c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5C20.5,15.9,16,17.9,10.3,17.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.3,22.6C4.5,22.6,0,20.5,0,18V4.6c0-0.3,0.2-0.5,0.5-0.5S1,4.3,1,4.6V18c0,1.7,3.8,3.6,9.3,3.6s9.3-1.9,9.3-3.6V4.6 c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V18C20.5,20.5,16,22.6,10.3,22.6z"
  }));
};

exports["default"] = _default;